import React from 'react';
import ReactDOM from 'react-dom';
import DpsApp from './DpsApp';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './routing/ScrollToTop';
import ScrollToAnchor from './routing/ScrollToAnchor';
import GoogleAnalyticsTracker from './routing/GoogleAnalyticsTracker';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleAnalyticsTracker />
      <ScrollToTop />
      <DpsApp />
      <ScrollToAnchor />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
